import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './authentication/shared/components/auth-layout/auth-layout.component';
import { LayoutComponent } from './portal/shared/components/layout/layout.component';
import { AuthGuard } from './portal/shared/guards/auth.guard';

export const routes: Routes = [
    {
      path: '',
      redirectTo: 'signin',
      pathMatch: 'full'
    },
    {
      path: '',
      component : AuthLayoutComponent,
      children: [
        {
          path: 'signin',
          loadComponent: () => import('./authentication/components/login/login.component').then(c => c.LoginComponent),
        },
        {
          path: 'forgot-password',
          loadComponent: () => import('./authentication/components/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent)
        },
        {
          path: 'linkedin',
          loadComponent: () => import('./authentication/shared/components/linkedin/linkedin.component').then(c => c.LinkedinComponent)
        }
      ]
    },
    {
      path: '',
      component: LayoutComponent,
      canActivate: [AuthGuard],
      children: [
        {
          path: 'profile',
          loadComponent: () => import('./portal/components/profile/profile.component').then(c => c.ProfileComponent)
        },
        {
          path: 'projects',
          loadComponent: () => import('./portal/components/projects/projects.component').then(c => c.ProjectsComponent)
        },
        {
          path: 'my-team',
          loadComponent: () => import('./portal/components/my-team/my-team.component').then(c => c.MyTeamComponent)
        },
        {
          path: 'my-team/employee/:id',
          loadComponent: () => import('./portal/components/employee-profile/employee-profile.component').then(c => c.EmployeeProfileComponent)
        },
        {
          path: 'timesheet/:projectId/:memberId',
          loadComponent: () => import('./portal/components/timesheet/timesheet.component').then(c => c.TimesheetComponent)
        },
        {
          path: 'timesheet',
          loadComponent: () => import('./portal/components/timesheet/timesheet.component').then(c => c.TimesheetComponent)
        }
      ]
    }
];

